
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ViewHeader extends Vue {

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////

    @Prop({ type: String, required: true }) title!: string
    @Prop({ type: Boolean, default: false }) flat!: boolean

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get classes () {
        return {
            'flat': this.flat,
        }
    }

}
